module.exports = __webpack_public_path__ + "static/media/Climate_ADAPT_logo_white.ddcdbdb5.svg";